import { render, staticRenderFns } from "./DueItems.vue?vue&type=template&id=11a49cf6&"
import script from "./DueItems.vue?vue&type=script&lang=js&"
export * from "./DueItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports